import React from "react";
import { useIntl } from "react-intl";
import { Row, Col, Icon, Table, Timeline } from "antd";

import { ReactComponent as Current } from "../icons/location.svg";

import "./index.css";

const { Item } = Timeline;

const Schedule = ({ history }) => {
  const intl = useIntl();
  const columns = [
    {
      key: "timeline",
      width: 50,
      render: (_value, _row, index) =>
        index === 0
          ? {
              props: { rowSpan: history ? history.length : 0 },
              children: (
                <Timeline>
                  {history &&
                    history.map((_item, i) =>
                      0 === i ? (
                        <Item key={i} color="black"></Item>
                      ) : (
                        <Item
                          key={i}
                          dot={
                            <Icon
                              component={Current}
                              className="timeline-last-icon"
                            />
                          }
                        ></Item>
                      )
                    )}
                </Timeline>
              ),
            }
          : { props: { rowSpan: 0, colSpan: 0 } },
    },
    {
      key: "place",
      title: intl.formatMessage({
        id: "tracking.place",
        defaultMessage: "Místo",
      }),
      dataIndex: "place",
      width: 200,
    },
    {
      key: "dateTime",
      title: intl.formatMessage({
        id: "tracking.dateTime",
        defaultMessage: "Čas",
      }),
      dataIndex: "dateTime",
      width: 220,
    },
    {
      key: "message",
      title: intl.formatMessage({
        id: "tracking.message",
        defaultMessage: "Status",
      }),
      dataIndex: "message",
    },
  ];
  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <div className="ant-descriptions-title">
              {intl.formatMessage({
                id: "tracking.transportDetail",
                defaultMessage: "Detail přepravy",
              })}
            </div>
          </Col>
        </Row>
        <Row className="schedule-history-row">
          <Col>
            <Table
              columns={columns}
              pagination={false}
              className="schedule-table"
              dataSource={
                history
                  ? [
                      ...history
                        .map((item, idx) => ({ ...item, key: idx }))
                        .reverse(),
                    ]
                  : []
              }
            ></Table>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Schedule;
